module.exports = __webpack_public_path__ + "img/nikola_semjaniv.b4e2060b.jpg";